import { graphql } from "msw";
import { mockCart } from "./mockCart";
import {
  AddItemsToCartMutationVariables,
  AddItemsToCartMutation,
} from "@cart-app/generated/graphql";
import { OFFER_ID_THAT_WILL_THROW_ERROR } from "@cart-app/mocks/constants";

export const handler = graphql.mutation<
  AddItemsToCartMutation,
  AddItemsToCartMutationVariables
>("AddItemsToCart", (req, res, ctx) => {
  const { items } = req.variables.itemsToBeAdded;

  if (items.some((item) => item.offerId == OFFER_ID_THAT_WILL_THROW_ERROR)) {
    return res(
      ctx.data({
        addItemsToCart: {
          __typename: "CartBatchMutationResponse",
          cart: mockCart,
          errors: [
            {
              offerId: OFFER_ID_THAT_WILL_THROW_ERROR,
              message: "Item is out of stock.",
            },
          ],
        },
      })
    );
  }

  return res(
    ctx.data({
      addItemsToCart: {
        __typename: "CartBatchMutationResponse",
        cart: mockCart,
        errors: [],
      },
    })
  );
});
